

























import { Component, Vue } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import SalesReportChart from '@accounting/components/charts/sales-report-chart.vue';
import { v4 as uuidv4 } from 'uuid';

import { DisplayOptions } from '@shared/interfaces/chart-interfaces';

@Component({
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-sales-report-chart': SalesReportChart,
  },
})
export default class SalesReportPage extends Vue {
  // Props

  // DATA
  // LIFECYCLE
  // created(){}
  // mounted() {}
  // updated(){}
  // destroyed(){}
  // COMPUTED

  displayOptions: DisplayOptions = {
    showChartBar: false,
    showChartLine: false,
    showChartArea: false,
    showChartPie: true,
  };

  get actionsPortalTarget() {
    return `user-evolution-actions-${uuidv4()}`;
  }
  get navigationPortalTarget() {
    return `user-evolution-navigation-${uuidv4()}`;
  }

  // METHODS

  // WATCHERS
}
